import React from "react";

interface MarkdownHintProps {
  show?: boolean;
}

/**
 * Composant d'indication de support markdown
 * Affiche une info-bulle pour guider l'utilisateur sur la syntaxe markdown disponible
 */
export const MarkdownHint: React.FC<MarkdownHintProps> = ({ show = true }) => {
  if (!show) return null;
  
  return (
    <div style={{
      fontSize: "0.875rem",
      color: "#6b7280",
      backgroundColor: "#f9fafb",
      padding: "0.75rem 1rem",
      borderRadius: "8px",
      border: "1px solid #e5e7eb",
      marginBottom: "0.75rem",
      display: "flex",
      alignItems: "start",
      gap: "0.5rem"
    }}>
      <span style={{ fontSize: "1.125rem", flexShrink: 0 }}>💡</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, marginBottom: "0.25rem" }}>
          Mise en forme disponible
        </div>
        <div style={{ fontSize: "0.8rem", lineHeight: "1.4", color: "#6b7280" }}>
          <strong>**gras**</strong>, <em>*italique*</em>, listes avec <code>-</code> ou <code>1.</code>
        </div>
      </div>
    </div>
  );
};

export default MarkdownHint;